'use client'

import { Card } from '@repo/ui/components'
import { SettingsCTA } from './settings.cta'
import { SettingsTheme } from './settings.theme'
import { SettingsLanguage } from './settings.language'
import { useIsDesktop } from '@repo/ui/hooks'

export const SettingsContainer = () => {
  const isDesktop = useIsDesktop()

  return (
    <Card className='!gap-3xl pb-4xl' withoutBorder>
      {isDesktop && <SettingsCTA origin='container' />}

      <SettingsTheme />
      <SettingsLanguage />
    </Card>
  )
}
